import React, { useState, useEffect } from "react";
import "./EventListView.css";
import _ from "lodash";
import NoMatch from "./NoMatch"; // Import your no match component
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, A11y } from "swiper/modules";
import { useEventContext } from "../util/EventProvider";
import { CarouselSkeleton } from "./CarouselSkeketon";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

export const Carousel = () => {
  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const {
    customEventDetails,
    eventInstances,
    loading,
    priceDetails,
    ticketData,
    studentPrices,
    generalAdmTicketTypeId,
    studentTicketTypeId,
    ticketTypeNames,
    availableStatus,
    customItems,
    list,
  } = useEventContext();

  const [filterTextValue, setFilterTextValue] = useState("Filter Program");
  const [filterTextValueTwo, setFilterTextValueTwo] =
    useState("Filter Instrument");
  const [view, setView] = useState("List");
  const [meetings, setMeetings] = useState([]);

  const formatDate = (dateTimeString) => {
    const dateObj = new Date(dateTimeString);
    const day = dateObj.toLocaleDateString("en-US", { weekday: "short" });
    const month = dateObj.toLocaleDateString("en-US", { month: "long" });
    const dateNumber = dateObj.getDate();
    const year = dateObj.getFullYear();
    const time = dateObj.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
    });

    return `${month} ${dateNumber} • ${time}`;
  };

  // Define the shared style properties for the tag labels
  const tagStyle = {
    padding: "6px", // Add padding to the container
    width: "auto",
    height: "5px",
    fontWeight: "normal", // Apply lighter font weight
    color: "#FFFFFF", // Set text color to white
    letterSpacing: "2px", // Increase letter-spacing to stretch out the text
    lineHeight: "0.1", // Adjust the height of the text
    fontSize: "0.6rem", // Adjust font size to make the text smaller
    background: "#2D2D2D", // Set the background color to white
    fontFamily: "Montserrat, sans-serif",
    textTransform: "uppercase",
  };

  const getDayOfWeek = (dateTimeString) => {
    const dateObj = new Date(dateTimeString);
    return dateObj
      .toLocaleDateString("en-US", { weekday: "short" })
      .slice(0, 3);
  };

  const getDateNumber = (dateTimeString) => {
    const dateObj = new Date(dateTimeString);
    return dateObj.getDate();
  };

  const getMonthName = (dateTimeString) => {
    const dateObj = new Date(dateTimeString);
    return dateObj.toLocaleDateString("en-US", { month: "long" });
  };

  const getYearName = (dateTimeString) => {
    const dateObj = new Date(dateTimeString);
    return dateObj.toLocaleDateString("en-US", { year: "numeric" });
  };

  const getTimeNumber = (dateTimeString) => {
    const dateObj = new Date(dateTimeString);
    return dateObj.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
    });
  };

  // Initialize an array to store event instances and its event id
  const eventInstancesArray = Object.entries(eventInstances).map(
    ([eventId, instances]) => ({
      eventId,
      eventInstances: instances,
    })
  );

  // Initialize an empty array to store the merged data
  const mergedEventDetails = [];

  // Iterate over one of the arrays, eventInstancesArray in this case
  eventInstancesArray.forEach(({ eventId, eventInstances }) => {
    // Find the corresponding event in filteredEvents array using the Event ID
    const event = list.find((event) => event.id === eventId);

    // If the event is found, merge the data and push it to the mergedArray
    if (event) {
      const instancePrice =
        priceDetails[eventId] !== undefined ? priceDetails[eventId] : null;
      mergedEventDetails.push({
        event,
        eventInstances,
        priceDetails,
        customItems,
        studentPrices,
        generalAdmTicketTypeId,
        studentTicketTypeId,
        ticketTypeNames,
        ticketData,
        availableStatus,
      });
    }
  });

  // Sort the mergedEventDetails array based on eventInstances start times
  mergedEventDetails.sort((a, b) => {
    // Get the start times of the instance for each event
    const startTimeA = new Date(a.eventInstances[0].start);
    const startTimeB = new Date(b.eventInstances[0].start);

    // Compare the start times and return the result
    return startTimeA - startTimeB;
  });

  function sortEventInstancesByDay(eventObject) {
    // Iterate over each event in the object
    for (let i = 0; i < eventObject.length; i++) {
      // Sort the eventInstances array by the start date
      eventObject[i].eventInstances.sort((a, b) => {
        const dateA = new Date(a.start);
        const dateB = new Date(b.start);
        return dateA - dateB;
      });
    }
    // Return the sorted event object
    return eventObject;
  }
  // Example usage:
  const sortedEventObject = sortEventInstancesByDay(mergedEventDetails);

  const transformedEventsTwo = sortedEventObject.map(
    ({
      event,
      eventInstances,
      priceDetails,
      customItems,
      studentPrices,
      studentTicketTypeId,
      generalAdmTicketTypeId,
      ticketTypeNames,
      ticketData,
      availableStatus,
    }) => {
      // Copy all properties of the event object
      const completeEventProperties = { ...eventInstances };

      // Add instances as a separate property
      completeEventProperties.eventDetails = event;

      // Add instances as a separate property
      completeEventProperties.priceDetails = priceDetails;

      // Add instances as a separate property
      completeEventProperties.customItems = customItems;

      // Add instances as a separate property
      completeEventProperties.studentPrices = studentPrices;

      // Add instances as a separate property
      completeEventProperties.studentTicketTypeId = studentTicketTypeId;

      // Add instances as a separate property
      completeEventProperties.generalAdmTicketTypeId = generalAdmTicketTypeId;

      // Add instances as a separate property
      completeEventProperties.ticketTypeNames = ticketTypeNames;

      // Add instances as a separate property
      completeEventProperties.ticketData = ticketData;

      // Add instances as a separate property
      completeEventProperties.availableStatus = availableStatus;

      // Return the new object
      return completeEventProperties;
    }
  );

  // Create an object to hold the grouped events
  const groupedEvents = {};

  // Iterate over the transformedEventsTwo and group events by date
  Object.values(transformedEventsTwo).forEach((instance) => {
    const startDate = instance[0].start.substring(0, 10); // Extract date part of the start time

    // Check if the date already exists in groupedEvents
    if (groupedEvents[startDate]) {
      // If the date exists, push the instance to the corresponding array
      groupedEvents[startDate].push(instance);
    } else {
      // If the date doesn't exist, create a new array with the instance
      groupedEvents[startDate] = [instance];
    }
  });

  const currentDate = new Date();

  // Filter the sortedEventList to include only events that have not passed
  const filteredEvents = customEventDetails.filter((event) => {
    const eventDate = new Date(event.start);
    return eventDate >= currentDate;
  });

  const filteredEventList = filteredEvents.filter((event) => {
    const filterByProgram =
      filterTextValue === "Filter Program" ||
      filterTextValue === event.attribute_EventCategory;

    const filterByInstrument =
      filterTextValueTwo === "Filter Instrument" ||
      filterTextValueTwo === event.attribute_EventTag2;
    return filterByProgram && filterByInstrument;
  });

  // Define a constant to represent when no matches are present
  const noMatchView = filteredEventList.length === 0;

  // Function to execute when there are no matches
  const handleNoMatch = () => {
    return <NoMatch />;
    //console.log("No matches found between filters!");
  };

  // Check if there are no matches and execute the function
  if (noMatchView && loading === false) {
    handleNoMatch();
  }

  // Get unique months from the filteredEventList
  const uniqueMonths = Array.from(
    new Set(
      filteredEventList.map(
        (event) => `${getMonthName(event.start)} ${getYearName(event.start)}`
      )
    )
  );

  useEffect(() => {
    // Filter customEventDetails to include only events with isOnSale true and a defined start property
    const filteredMeetings = customEventDetails.filter(
      (event) => event && event.isOnSale && event.start
    );

    // Check if meetings need to be updated before setting state
    if (JSON.stringify(filteredMeetings) !== JSON.stringify(meetings)) {
      // Set the meetings state once with filteredMeetings
      setMeetings(filteredMeetings);
    }
  }, [customEventDetails, meetings]); // Add meetings as a dependency

  uniqueMonths.sort((a, b) => {
    // Extract year and month from each string (e.g., "February 2024")
    const [monthA, yearA] = a.split(" ");
    const [monthB, yearB] = b.split(" ");
    // Compare years first
    if (yearA !== yearB) {
      return parseInt(yearA) - parseInt(yearB);
    } else {
      // If years are the same, compare months
      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      return months.indexOf(monthA) - months.indexOf(monthB);
    }
  });

  // Sort all events by start date
  const allEventsInOrder = filteredEventList.sort((a, b) => {
    const dateA = new Date(a.start);
    const dateB = new Date(b.start);
    return dateA - dateB;
  });

  // Render list items
  const listItems = allEventsInOrder.filter((event) => {
    const eventMonthYear = `${getMonthName(event.start)} ${getYearName(
      event.start
    )}`;
    //return eventMonthYear === monthYear;
  });

  //console.log(createdEventIds);

  function areAllInstancesSoldOutForDay(allEventsInOrder, eventId, day) {
    // Group instances by day and event ID
    const instancesGroupedByDayAndEventId = {};

    allEventsInOrder.forEach((instance) => {
      const instanceDay = instance.start.split("T")[0]; // Extracting the date from the timestamp
      const instanceEventId = instance.id;

      // Creating a unique key for each day and event ID combination
      const key = `${instanceDay}-${instanceEventId}`;

      if (!instancesGroupedByDayAndEventId[key]) {
        instancesGroupedByDayAndEventId[key] = [];
      }
      instancesGroupedByDayAndEventId[key].push(instance);
    });

    // Get instances of the given event happening on the provided day
    const key = `${day}-${eventId}`;
    const instancesOnDayAndEventId = instancesGroupedByDayAndEventId[key] || [];
    //console.log(instancesOnDayAndEventId);
    // Check if all instances for the day and event ID are sold out
    const allSoldOut = instancesOnDayAndEventId.every(
      (instance) => instance.availableStatus === 0
    );
    return { allSoldOut, instancesOnDayAndEventId };
  }

  function areAllInstancesSoldOut(events) {
    // Iterate through each event in the array
    for (const event of events) {
      // Check if any instance of the event has availableStatus !== 0
      const soldOut = event.every((instance) => instance.availableStatus === 0);
      // If any instance is not sold out, return false
      if (!soldOut) {
        return false;
      }
    }
    // If all instances of all events are sold out, return true
    return true;
  }

  // Define an array to store the keys of rendered events
  const renderedEventKeys = new Set();

  const renderedTimes = Object.keys(eventInstances).map((key) => {
    return { key, value: eventInstances[key] };
  });

  const handleLinkClick = (path, eventDate, eventId) => {
    localStorage.setItem("eventDate", eventDate);
    localStorage.setItem("eventIdTwo", eventId);
    // Navigate the parent window to the specified path
    window.parent.location.href = path;
  };

  //console.log(`Number of unique event IDs: ${uniqueEventIds}`);

  function checkEventInUniqueMonths(event) {
    // Ensure `event` is defined and has the required properties
    if (!event || !event.id || !event.start) {
      console.error("Invalid event data:", event);
      return null;
    }

    // Generate a unique key for the event instance
    const eventKey = `${event.id}-${getDateNumber(event.start)}`;

    // Example usage
    const eventId = event.id; // Event ID to check
    const day = event.start.split("T")[0]; // Day to check (extracting date from timestamp)

    const { allSoldOut, instancesOnDayAndEventId } =
      areAllInstancesSoldOutForDay(allEventsInOrder, eventId, day);

    // Ensure `customEventDetails` is defined and is an array
    const validCustomEventDetails = Array.isArray(customEventDetails)
      ? customEventDetails
      : [];

    // Filter events where isOnSale is true
    const eventsOnSale = validCustomEventDetails
      .filter((event) => event.isOnSale) // Filter out events that are not on sale
      .filter((event) => event.start); // Filter out events without a start date

    // Ensure `eventInstances` is defined and is an object
    const validEventInstances = eventInstances || {};

    // Filter out instances where isOnSale is true
    const filteredInstances = Object.values(validEventInstances).reduce(
      (acc, instances) => {
        const validInstances = Array.isArray(instances) ? instances : []; // Ensure instances is an array
        const filtered = validInstances.filter((instance) => instance.isOnSale);
        return acc.concat(filtered);
      },
      []
    );

    // Group instances by event id
    const groupedInstances = filteredInstances.reduce((acc, instance) => {
      const instanceEventId = instance.event.id; // Use a different variable name to avoid shadowing
      if (!acc[instanceEventId]) {
        acc[instanceEventId] = [];
      }
      acc[instanceEventId].push(instance);
      return acc;
    }, {});

    // Ensure `groupedInstances[eventId]` is defined and is an array
    const instancesForEventId = Array.isArray(groupedInstances[eventId])
      ? groupedInstances[eventId]
      : [];

    // Group events by day
    const eventsByDay = instancesForEventId.reduce((acc, event) => {
      const startDate = new Date(event.start);
      const day = startDate.toLocaleDateString("en-US", {
        weekday: "long",
        month: "long",
        day: "numeric",
      });
      if (!acc[day]) {
        acc[day] = [];
      }
      acc[day].push(event);
      return acc;
    }, {});

    // Create a mapping from eventId to event details with multiple instances
    const eventsMap = eventsOnSale.reduce((map, event) => {
      if (!map[event.id]) {
        map[event.id] = {
          ...event,
          instances: [],
        };
      }
      // Push instance data into the array
      map[event.id].instances.push({
        instanceId: event.instanceId,
        availableStatus: event.availableStatus,
        name: event.name,
        start: event.start,
        eventId: event.id,
        // Add other relevant instance data here
      });
      map[event.id].instances.sort(
        (a, b) => new Date(a.start) - new Date(b.start)
      );

      return map;
    }, {});

    // Create a new array where each element is an object with eventId as key and instances[] as value
    const eventInstancesArray = Object.entries(eventsMap).map(
      ([eventId, eventDetails]) => ({
        eventId: eventId,
        instances: eventDetails.instances,
      })
    );

    // Assuming eventsByDay and eventsMap are defined

    // Loop through each day in eventsByDay
    Object.entries(eventsByDay).forEach(([day, events]) => {
      // Loop through each event in the current day
      events.forEach((event) => {
        const tempEventId = event.event.id;
        const eventId = tempEventId.match(/[a-zA-Z0-9]+/)?.[0] || tempEventId;

        // Check if eventId exists in eventsMap
        if (eventsMap[eventId]) {
          // Add the instances to the event
          event.instances = eventsMap[eventId].instances;
        } else {
          // Initialize instances as an empty array if no instances are found
          event.instances = [];
        }
      });
    });

    const getShortEventId = (eventId) => {
      return eventId.substring(0, 5);
    };

    // Check if the event key exists in the array of rendered event keys
    if (!renderedEventKeys.has(eventKey)) {
      // Add the event key to the array of rendered event keys
      renderedEventKeys.add(eventKey);

      // Return JSX to render the event
      return !event.attribute_HideEvent &&
        event.attribute_EventCategory === "Summer Concerts: Dobbs Ferry" ? (
        <div className="">
          <SwiperSlide className="flex flex-col overflow-hidden">
            {/* Container for events */}
            <div className="flex px-2">
              {/* Render events for this month */}
              <div className="grid">
                <div className="h-full" style={{ background: "#0D0D0D" }}>
                  <div
                    style={{
                      position: "relative",
                      width: "auto",
                      height: "auto",
                    }}
                  >
                    <a
                      href={
                        event.attribute_FreeEvent === true ||
                        event.name === "Jam Session"
                          ? `/visit/${getShortEventId(eventId)}`
                          : `/event/${getShortEventId(eventId)}`
                      }
                      onClick={(e) => {
                        // Allow default behavior if metaKey or ctrlKey is pressed
                        if (e.metaKey || e.ctrlKey) {
                          return; // Let the default action proceed
                        }
                        e.preventDefault(); // Prevent default behavior for other clicks
                        handleLinkClick(
                          event.attribute_FreeEvent === true
                            ? `/visit/${getShortEventId(eventId)}`
                            : `/event/${getShortEventId(eventId)}`,
                          event.start,
                          eventId
                        );
                      }}
                      //onContextMenu={(e) => e.preventDefault()} // Disable right-click
                      style={{
                        fontFamily: "Montserrat, sans-serif",
                        textTransform: "uppercase",
                        fontWeight: "bold",
                        fontSize: "14px",
                        pointerEvents: loading ? "none" : "auto", // Disable pointer events when loading
                        display: "block", // Ensure <a> behaves like a block element
                        textDecoration: "none", // Remove default link underline
                      }}
                    >
                      <img
                        loading="lazy"
                        src={event.imageUrl}
                        alt={event.name}
                        className="w-full object-cover object-center scale-98 sm:scale-100"
                      />
                    </a>
                    <div
                      className="flex sm:flex-row flex-wrap sm:space-x-2 space-x-1 items-start"
                      style={{
                        position: "absolute",
                        bottom: "0",
                        left: "0",
                        width: "100%",
                        zIndex: "2",
                        marginBottom: ".4rem",
                        marginLeft: ".4rem",
                      }}
                    >
                      {/* Conditionally render tag 1 if it's not null */}
                      {event.attribute_EventTag1 && (
                        <div className="text-align-center">
                          <label
                            className="bg-zinc-800"
                            style={{
                              padding: "3px",
                              width: "auto",
                              height: "5px",
                              fontWeight: "lighter",
                              color: "white",
                              letterSpacing: "1px",
                              lineHeight: "1rem",
                              fontSize: "0.7rem",
                              fontFamily: "Montserrat, sans-serif",
                              textTransform: "uppercase",
                            }}
                          >
                            {event.attribute_EventTag1}
                          </label>
                        </div>
                      )}
                      {/* Conditionally render tag 2 if it's not null */}
                      {event.attribute_EventTag2 && (
                        <div className="text-align-center">
                          <label
                            className="bg-zinc-800"
                            style={{
                              padding: "3px",
                              width: "auto",
                              height: "2px",
                              fontWeight: "lighter",
                              color: "white",
                              letterSpacing: "1px",
                              lineHeight: "1rem",
                              fontSize: "0.7rem",
                              fontFamily: "Montserrat, sans-serif",
                              textTransform: "uppercase",
                            }}
                          >
                            {event.attribute_EventTag2}
                          </label>
                        </div>
                      )}
                      {/* Conditionally render tag 3 if it's not null */}
                      {event.attribute_EventTag3 && (
                        <div className="text-align-center">
                          <label
                            className="bg-zinc-800"
                            style={{
                              padding: "3px",
                              width: "auto",
                              height: "2px",
                              fontWeight: "lighter",
                              color: "white",
                              letterSpacing: "1px",
                              lineHeight: "1rem",
                              fontSize: "0.7rem",
                              fontFamily: "Montserrat, sans-serif",
                              textTransform: "uppercase",
                            }}
                          >
                            {event.attribute_EventTag3}
                          </label>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="flex flex-col sm:space-y-0">
                    {/* Event name */}
                    {event.name && (
                      <h3
                        className="text-2xl text-left"
                        style={{
                          fontFamily: "Norwester, sans-serif",
                          textTransform: "uppercase",
                          padding: "8px 0px",
                          fontStyle: "normal",
                          lineHeight: "1.2", // Adjusted line height
                          whiteSpace: "normal", // Allow text to wrap naturally
                          wordBreak: "break-word", // Ensure long words break onto the next line
                          overflowWrap: "break-word", // Ensure words break to prevent overflow
                        }}
                      >
                        {event.name}
                      </h3>
                    )}
                    {/* Dates and Instances */}
                    {Object.entries(eventsByDay)
                      .slice(0, 3)
                      .map(([day, instances]) => (
                        <div key={day} className="h-full">
                          {/* Day as headline */}
                          <p
                            className="text-lg font-bold"
                            style={{
                              fontFamily: "Montserrat, sans-serif",
                              padding: "8px 0px",
                              fontWeight: "bold",
                              lineHeight: "1",
                            }}
                          >
                            {day}
                          </p>
                          {/* Render instances and button in a single row */}
                          <div className="flex items-center flex-cols-1">
                            {instances.map((instance, instanceIndex) => {
                              // Log to verify instance data
                              //console.log(`Instance Data:`, instance);

                              // Check if there are instances for the event
                              const instancesArray = instance.instances || [];

                              // Find the instance with the matching id
                              const matchedInstance = instancesArray.find(
                                (inst) => inst.instanceId === instance.id
                              );

                              //console.log(matchedInstance)

                              // Determine if the instance is sold out
                              const isSoldOut = matchedInstance
                                ? matchedInstance.availableStatus === 0
                                : false; // Adjust this condition based on your requirements

                              //console.log(instancesArray);
                              // Log details for debugging
                              //console.log(`Event Name: ${event.name}, Instance ID: ${instance.id}, Event ID: ${instance.event.id}, Available Status: ${matchedInstance ? matchedInstance.availableStatus : 'N/A'}, Is Sold Out: ${isSoldOut}`);

                              return (
                                <React.Fragment key={instance.instanceId}>
                                  {/* Instance time */}
                                  <div>
                                    <p
                                      className="text-ms"
                                      style={{
                                        fontFamily: "Montserrat, sans-serif",
                                        textTransform: "uppercase",
                                        fontWeight: "light",
                                      }}
                                    >
                                      {getTimeNumber(instance.start)}
                                    </p>
                                  </div>
                                  {/* Button */}
                                  <div className="px-1">
                                    <div className="flex flex-grid grid-cols-4 items-center">
                                      {event.attribute_FreeEvent === true ||
                                      event.name === "Jam Session" ? (
                                        // Render "Event Info" button
                                        <a
                                          className="linkCarousel"
                                          href={`/visit/${getShortEventId(
                                            eventId
                                          )}`}
                                          onClick={(e) => {
                                            e.preventDefault();
                                            handleLinkClick(
                                              `/visit/${getShortEventId(
                                                eventId
                                              )}`,
                                              event.start,
                                              eventId
                                            );
                                          }}
                                          onContextMenu={(e) =>
                                            e.preventDefault()
                                          }
                                          style={{
                                            fontFamily:
                                              "Montserrat, sans-serif",
                                            textTransform: "uppercase",
                                            fontWeight: "bold",
                                            fontSize: "14px",
                                          }}
                                        >
                                          Event Info
                                        </a>
                                      ) : isSoldOut ? (
                                        // Render "Sold Out" button
                                        <a
                                          href={`/event/${getShortEventId(
                                            eventId
                                          )}`}
                                          onClick={(e) => {
                                            e.preventDefault();
                                            handleLinkClick(
                                              `/event/${getShortEventId(
                                                eventId
                                              )}`,
                                              event.start,
                                              eventId
                                            );
                                          }}
                                          onContextMenu={(e) =>
                                            e.preventDefault()
                                          }
                                          style={{
                                            fontFamily:
                                              "Montserrat, sans-serif",
                                            textTransform: "uppercase",
                                            fontWeight: "bold",
                                            fontSize: "14px",
                                            color: "#FFFFFF",
                                          }}
                                        >
                                          Sold Out
                                        </a>
                                      ) : (
                                        // Render the regular button for buying tickets
                                        <a
                                          className="linkCarousel"
                                          href={`/event/${getShortEventId(
                                            eventId
                                          )}`}
                                          onClick={(e) => {
                                            e.preventDefault();
                                            handleLinkClick(
                                              `/event/${getShortEventId(
                                                eventId
                                              )}`,
                                              event.start,
                                              eventId
                                            );
                                          }}
                                          onContextMenu={(e) =>
                                            e.preventDefault()
                                          }
                                          style={{
                                            fontFamily:
                                              "Montserrat, sans-serif",
                                            textTransform: "uppercase",
                                            fontWeight: "bold",
                                            fontSize: "14px",
                                          }}
                                        >
                                          {loading ? "Loading..." : "Tickets"}
                                        </a>
                                      )}
                                    </div>
                                  </div>
                                  {/* Add a separator if it's not the last instance */}
                                  {instanceIndex < instances.length - 1 && (
                                    <span className="mr-.5 text-xl">
                                      {" "}
                                      &nbsp;|&nbsp;{" "}
                                    </span>
                                  )}
                                </React.Fragment>
                              );
                            })}
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        </div>
      ) : null;
    }
    return null;
  }

  // Declare renderedEventIds outside the JSX return statement
  const renderedEventIds = new Set();

  const summerConcertsDobbsFerry = allEventsInOrder.filter(
    (event) =>
      !event.attribute_HideEvent &&
      event.attribute_EventCategory === "Summer Concerts: Dobbs Ferry"
  );

  return (
    <div
      style={{
        position: "relative",
        minHeight: "100%",
        paddingLeft: "25px",
        paddingRight: "25px",
      }}
    >
      {loading ? (
        // Render the loading skeleton while data is loading
        <CarouselSkeleton />
      ) : summerConcertsDobbsFerry.length > 0 ? (
        // Render the Swiper carousel if events are available
        <>
          <Swiper
            container={{
              loop: true,
            }}
            breakpoints={{
              300: {
                slidesPerView: 1,
                spaceBetween: 5,
              },
              480: {
                slidesPerView: 1,
                spaceBetween: 5,
              },
              600: {
                slidesPerView: 2,
                spaceBetween: 5,
              },
              980: {
                slidesPerView: 3,
                spaceBetween: 5,
              },
              1280: {
                slidesPerView: 4,
                spaceBetween: 5,
              },
            }}
            navigation={{
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            }}
            modules={[Pagination, Navigation, A11y]}
            className="min-w-[90%] min-h-[100%]"
            style={{ whiteSpace: "nowrap", width: "auto" }}
          >
            {summerConcertsDobbsFerry.map((event) => {
              // Check if the event ID has already been rendered
              if (!renderedEventIds.has(event.id)) {
                // Add the event ID to the Set of rendered event IDs
                renderedEventIds.add(event.id);
                // Render the event component
                return (
                  <div className="" key={event.id}>
                    {checkEventInUniqueMonths(event)}
                  </div>
                );
              }
              // Return null if the event has already been rendered
              return null;
            })}
          </Swiper>

          {/* Navigation arrows */}
          <div
            style={{
              position: "absolute",
              top: "50%",
              transform: "translateY(-50%)",
              left: "-12px",
              right: "-12px",
              zIndex: "100",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div>
              <div className="swiper-button-prev white-arrow"></div>
            </div>
            <div>
              <div className="swiper-button-next white-arrow"></div>
            </div>
          </div>
        </>
      ) : (
        // Render the message if no summer concerts are available
        <p
          style={{
            fontFamily: "Montserrat, sans-serif",
          }}
        >
          Currently there are no events available. Summer concerts are scheduled
          during spring.
        </p>
      )}
    </div>
  );
};
